export default __webpack_public_path__ + "static/media/ic-cc-4.00dd8b3d.svg";